module.exports = __webpack_public_path__ + "static/img/3.19fdc03.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/2/sp/3.png
// module id = XsQP
// module chunks = 0